import { usePostEventMutation } from "@/store/api/tinybirdApi";
import { useCallback, useRef } from "react";
import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

const getSessionID = () => {
  let sessionId = localStorage.getItem("session_id");
  if (!sessionId) {
    sessionId = uuidv4();
    localStorage.setItem("session_id", sessionId);
  }
  return sessionId;
};

const getBrowserInfo = () => {
  const ua = navigator.userAgent;
  let browser = "unknown";
  let os = "unknown";
  let deviceType = "desktop";

  // Detect browser
  if (ua.includes("Edge/")) browser = "edge";
  else if (ua.includes("Chrome/")) browser = "chrome";
  else if (ua.includes("Safari/")) browser = "safari";
  else if (ua.includes("Firefox/")) browser = "firefox";
  else if (ua.includes("MSIE ") || ua.includes("Trident/")) browser = "ie";

  // Detect OS
  if (ua.includes("Windows")) os = "windows";
  else if (ua.includes("Mac OS")) os = "macos";
  else if (ua.includes("Linux")) os = "linux";
  else if (ua.includes("Android")) os = "android";
  else if (ua.includes("iOS")) os = "ios";

  // Detect device type
  if (ua.includes("Mobile")) deviceType = "mobile";
  else if (ua.includes("Tablet")) deviceType = "tablet";

  return { browser, os, deviceType };
};

const useEventTracking = () => {
  const location = useLocation();
  const [eventSend] = usePostEventMutation();
  const hasSentEvent = useRef(false);

  // Return a function that can be called when resources are loaded
  return useCallback(async () => {
    // Prevent duplicate tracking
    if (hasSentEvent.current) return;

    const branchId = JSON.parse(
      localStorage.getItem("selectedBranch") || "{}",
    )?.id;

    // Don't track if there's no branch loaded
    if (!branchId) return;

    const sessionId = getSessionID();
    const { browser, os, deviceType } = getBrowserInfo();
    const urlParams = new URLSearchParams(window.location.search);

    const currentDate = new Date();
    const visitData = {
      visit_id: sessionId,
      timestamp: currentDate.toUTCString(),
      branch_id: branchId,
      device_type: deviceType,
      customer_id:
        JSON.parse(localStorage.getItem("customer_data") || "{}")?.name || "",
      os: os,
      browser: browser,
      referrer: document.referrer || "",
      utm_source: urlParams.get("utm_source") || "",
      utm_medium: urlParams.get("utm_medium") || "",
      utm_campaign: urlParams.get("utm_campaign") || "",
      region: "",
      city: "",
    };

    hasSentEvent.current = true;
    await eventSend(visitData);
  }, [eventSend, location]);
};

export default useEventTracking;
